module.exports = __webpack_public_path__ + "static/media/icon-star.2e426d8f.svg";